/** Page background token shared by the demo shell and mesh overlay. */
export function getShellPageBackgroundColor(): string {
  return "light-dark(var(--mantine-color-gray-dark-3), var(--mantine-color-gray-dark-10))";
}
